import api from '@/services/api/config';

const path = 'v1/infra/wareneingang';

export default {
  get: (page, size, sort = null, desc = false, suche = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche,
    },
  }),
  getOhneWep: (page, size, sort = null, desc = false, suche = null) => api.get(`${path}/ohne-pruefung`, {
    params: {
      page, size, sort, desc, suche,
    },
  }),
  countOhneWep: (suche = null) => api.get(`${path}/ohne-pruefung/count`, {
    params: {
      suche,
    },
  }),
  doImport: () => api.post(`${path}/import`),
};
